export const site = {
  "product": "Sovasta Link",
  "packageName": "sovelink",
  "service": "sovelink",
  "domain": "link.sovetrust.com",
  "sections": [
    "overview",
    "feed",
    "studio",
    "analytics",
    "community",
    "pricing",
    "support",
    "account"
  ],
  "labels": {
    "overview": "Overview",
    "feed": "Feed",
    "studio": "Studio",
    "analytics": "Analytics",
    "community": "Community",
    "pricing": "Pricing",
    "support": "Support",
    "account": "Account"
  },
  "kicker": "CREATOR FEED OS · VISUAL SUBSTACK",
  "title": "Turn your research into a paid visual feed.",
  "body": "Sovasta Link helps analysts, newsletter writers, and data creators publish a clean feed, gate premium posts, track subscribers, and package proof that can later become a sellable media asset.",
  "primary": "Launch my paid feed",
  "secondary": "See creator studio",
  "proof": "Creator PWA · Native paywall · Subscriber analytics",
  "onboarding": "Choose a niche, add one signature format, and preview the paid feed before account creation.",
  "demoTitle": "Creator command center",
  "demoName": "Macro Signals Feed · $2,840 MRR",
  "demoSignal": "Signal: 418 subscribers + 64% paid retention",
  "lines": [
    "A pinned thesis becomes today’s public note.",
    "Premium charts stay behind the paid wall.",
    "Analytics show which posts convert readers into members."
  ],
  "workspaceTitle": "Build a feed people will pay to follow.",
  "workspaceBody": "Start with a niche, a cadence, and a promise. Sovasta Link turns it into a branded feed, subscription page, and evidence-backed growth plan.",
  "field1": "Feed name",
  "field2": "Niche",
  "field3": "Paid promise",
  "default1": "Sovereign Macro Notes",
  "default2": "AI infrastructure and markets",
  "default3": "One visual thesis each weekday before the market opens",
  "flowTitle": "Publishing loop",
  "cards": [
    "Write visual brief",
    "Gate premium insight",
    "Track paid readers",
    "Package asset proof"
  ],
  "pricing": [
    [
      "Free",
      "$0",
      "Included in Sovasta — one subscription across every Sovasta solution."
    ],
    [
      "Basic",
      "$9/mo",
      "Included in Sovasta — one subscription across every Sovasta solution."
    ],
    [
      "Pro",
      "$29/mo",
      "Included in Sovasta — one subscription across every Sovasta solution."
    ],
    [
      "Premium",
      "$99/mo",
      "Included in Sovasta — one subscription across every Sovasta solution."
    ]
  ],
  "supportPrompt": "Ask how to choose a niche, price a paid feed, import posts, or improve subscriber retention."
} as const;
